import React from 'react';
import {Image} from "react-bootstrap";


export default function NoSolutionsFound() {
    return(
        <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <Image
                className="mb-2 no-match-found"
                src={require("../img/no-match.png").default} />
            <h2 className="mb-3">Sorry! <br/>We couldn´t find any matches.</h2>
            <p>Please try to use another combination.</p>
        </div>
    );
}